import React, { useState } from "react";
import Header from "../../layout/Header";
import SampleFile from "../../../sample/transactions/TransactionData.csv";
import { Link, useLocation } from "react-router-dom";
import { downloadIcon, uploadCSVIcon, rocketLaunch, summaryFileIcon } from "../../../Image/Index";
import { transactionValidateUserJourneyCSV, histTransactionBulkUpload } from "../../../actions/auth";

const ImportTransaction = () => {
    const location = useLocation();
    const [nextTab, setNextTab] = useState(0);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState("");
    const [isEnable, setIsEnable] = useState(true);
    const [state, setState] = useState({
        totalCustomer: "",
        progressComplete: false,
        progressLoading: false,
    });
    const { totalCustomer, progressComplete, progressLoading } = state;

    const onchangeFile = async (event) => {
        const maxFileSize = 25; // Max File Size

        if (event.target.files[0].type === "text/csv") {
            if (event.target.files[0].size > maxFileSize * 1024 * 1024) {
                setMessage("exceed maximum file size");
            } else {
                let response = await transactionValidateUserJourneyCSV(event.target.files[0]);
                const { message, totalCount } = response;
                if (message === "valid csv") {
                    setMessage(message);
                    setFile(event.target.files[0]);
                    setState({ ...state, totalCustomer: totalCount });
                    setIsEnable(false);
                } else {
                    setMessage(message);
                    setIsEnable(true);
                    setState({ ...state, totalCustomer: "" });
                }
            }
        } else {
            setMessage("File isn't in csv format");
        }
    };

    const uploadFile = async () => {
        const token = JSON.parse(localStorage.getItem("token_gen"));
        setNextTab(2);
        setState({ ...state, progressLoading: true });
        const res = await histTransactionBulkUpload(file, token?.access_token);
        setState({ ...state, progressComplete: true, progressLoading: false });
        if (res.message === "success") {
            setMessage(res.message);
        } else {
            setMessage(res.message);
        }
    };

    return (
        <>
            <Header name={"Import transaction"} />
            <div className="dashboard__content">
                <div className="dashboard__importCustomers">
                    <div className="dashboard__importHeading">
                        <Link to={location?.state?.prevPath ? "/transactions-list" : "/my-campaigns"}>
                            <i className="fa-solid fa-arrow-left"></i> Back
                        </Link>
                        <h6>Import Transaction</h6>
                        <p>
                            Import your transaction in bulk{" "}
                            <span title="This option will help you to upload transaction file to our portal in bulk for campaign qualification.">
                                <i className="fa-solid fa-circle-info"></i>
                            </span>
                        </p>
                    </div>
                    <div className="dashboard__importMainBox">
                        {nextTab === 0 && (
                            <div className="dashboard__importBox dashboard__importBox--stepOne">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li className="active">
                                            <span className="dashboard__importNumber">1</span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">2</span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        Download our sample
                                        <Link to={SampleFile} download="TransactionSampleFile" target="_blank">
                                            CSV file <img src={downloadIcon} alt="" />
                                        </Link>
                                    </p>
                                    <p>
                                        <i className="fa-solid fa-check"></i>Add the transaction details according to created campaign.If you have more than 100 transaction import in batches.
                                    </p>
                                    <p>
                                        <i className="fa-solid fa-check"></i>Double check each data is next to the correct numbers of columns.
                                    </p>
                                </div>
                                <div className="dashboard__importFooter">
                                    <button className="btn btn-primary btn-lg" onClick={() => setNextTab(1)}>
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                        {nextTab === 1 && (
                            <div className="dashboard__importBox dashboard__importBox--stepTwo">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li className="active">
                                            <span className="dashboard__importNumber">2</span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <form className="dashboard__importForm" encType="multipart/form-data">
                                        <div className="dashboard__importFormImage">
                                            <img src={uploadCSVIcon} alt="" />
                                        </div>
                                        {message ? (
                                            <div className="dashboard__importFormDescription">
                                                <div className="dashboard__importFormTitle" style={{ flexDirection: "column" }}>
                                                    <span className="dashboard__importFormLeft">{message === "valid csv" ? <span>File selected</span> : <span>We can't use this file.</span>}</span>{" "}
                                                    <span className="dashboard__importFormRight" style={{ margin: "0" }}>
                                                        <span className="dashboard__importFormText">
                                                            {message === "valid csv" && !isEnable && (
                                                                <button type="button" className="btn btn-sm btn-light" onClick={() => setMessage("")}>
                                                                    {file.name} X
                                                                </button>
                                                            )}
                                                            {message === "empty file" && <span>This file is empty</span>}
                                                            {message === "file length should be 100 rows" && <span>file length should be 100 rows</span>}
                                                            {message && isEnable && <span>{message}</span>}
                                                            {message === "File isn't in csv format" && <span>File isn't in csv format</span>}
                                                            {message === "exceed maximum file size" && <span>File size exceeds the limit of 25 MB</span>}
                                                        </span>
                                                    </span>
                                                </div>
                                                {message === "valid csv" && !isEnable ? null : (
                                                    <div className="dashboard__importFormSubtitle">
                                                        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setMessage("")}>
                                                            <i className="fas fa-redo"></i> Try again
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="dashboard__importFormDescription">
                                                <div className="dashboard__importFormTitle">
                                                    <span className="dashboard__importFormLeft">Drop your CSV file here or</span>
                                                    <span className="dashboard__importFormRight">
                                                        <span className="dashboard__importFormText">select a file from your computer</span>
                                                        <input className="dashboard__importFormTInput" type="file" accept={".csv"} onChange={onchangeFile} />
                                                    </span>
                                                </div>
                                                <div className="dashboard__importFormSubtitle">Maximum file size is 25 MB</div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                                <div className="dashboard__importFooter">
                                    <button className="btn btn-outline-primary" onClick={() => setNextTab(0)}>
                                        Back
                                    </button>
                                    <button className="btn btn-primary" disabled={message === "valid csv" ? false : true} onClick={uploadFile}>
                                        Upload File
                                    </button>
                                </div>
                            </div>
                        )}
                        {nextTab === 2 && (
                            <div className="dashboard__importBox dashboard__importBox--stepThree">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li className="active">
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                        </li>
                                    </ul>
                                </div>

                                <div className="dashboard__importBody">
                                    <form className="dashboard__importForm">
                                        <div className="dashboard__importFormImage">
                                            <img src={uploadCSVIcon} alt="" />
                                        </div>
                                        <div className="dashboard__importFormDescription">
                                            <div className="dashboard__importFormTitle" style={{ flexDirection: "column" }}>
                                                <span className="dashboard__importFormLeft" style={{ margin: "0 0 10px" }}>
                                                    FILE NAME
                                                </span>
                                                <span className="dashboard__importFormRight" style={{ margin: "0" }}>
                                                    {progressLoading && (
                                                        <div className="dashboard__importProgressBarBox">
                                                            <div className="dashboard__importProgressBar">
                                                                <span className="dashboard__importProgressBarFill" style={{ width: "100%" }}></span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {progressComplete && setNextTab(3)}
                                                </span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="dashboard__importFooter"></div>
                            </div>
                        )}
                        {nextTab === 3 && (
                            <div className="dashboard__importBox dashboard__importBox--stepFour">
                                <div className="dashboard__importHeader">
                                    <ul>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Prepare your file</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li>
                                            <span className="dashboard__importNumber">
                                                <i className="fa-solid fa-check"></i>
                                            </span>
                                            <span className="dashboard__importText">Upload</span>
                                            <span className="dashboard__importArrow">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                        </li>
                                        <li className="active">
                                            <span className="dashboard__importNumber">3</span>
                                            <span className="dashboard__importText">{message === "success" ? "Import Transactions" : "Import failed"}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dashboard__importBody">
                                    <div className="dashboard__importForm dashboard__importForm--column">
                                        <div className="dashboard__importFormImage">
                                            <img src={rocketLaunch} alt="" />
                                        </div>
                                        <div className="dashboard__importFormDescription">
                                            <div className="dashboard__importFormTitle">
                                                <span className="dashboard__importFormLeft">{message === "success" ? "Import successfully" : message}</span>
                                                <span className="dashboard__importFormRight">
                                                    <span className="dashboard__importFormText">
                                                        {message === "success" ? (
                                                            <>
                                                                Your transactions data is successfully imported in the system. Click on this link <Link to="/transactions-list">Transactions List</Link> to view the list of your transactions.
                                                            </>
                                                        ) : (
                                                            `There is a problem on the server side. Please try Some time later.`
                                                        )}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="dashboard__importSidebar">
                        {!progressComplete ? (
                            <>
                                <div className="dashboard__importSidebarHeader">
                                    <p>following this example to formate your CSV file:</p>
                                </div>
                                <div className="dashboard__importSidebarBody">
                                    <div className="table-responsive">
                                        <table className="table table-striped table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>T_row_type</th>
                                                    <th>C_mobile</th>
                                                    <th>T_account_number</th>
                                                    <th>T_merchant_id</th>
                                                    <th>T_terminal_id</th>
                                                    <th>T_transactionDate</th>
                                                    <th>T_transaction_time</th>
                                                    <th>T_post_date</th>
                                                    <th>T_transaction_location</th>
                                                    <th>T_amount</th>
                                                    <th>T_transaction_id</th>
                                                    <th>T_mcc</th>
                                                    <th>T_transactionMethodKey</th>
                                                    <th>T_transactionChannel</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>2</td>
                                                    <td>2983423236</td>
                                                    <td>100623424324</td>
                                                    <td>TEST0000</td>
                                                    <td>1234</td>
                                                    <td>2023-12-05T00:00:00.000Z</td>
                                                    <td>12:21:20 PM</td>
                                                    <td>1/1/2023</td>
                                                    <td>delhi india</td>
                                                    <td>67</td>
                                                    <td>TEST123456784567</td>
                                                    <td>978452</td>
                                                    <td>Birthday</td>
                                                    <td>Birthday Bonus</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="dashboard__importSidebarFooter">
                                    <p>
                                        Need help?{" "}
                                        <Link to="/help-details" state={{ fileGuideline: "Transactions" }}>
                                            See our file guidelines <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                        </Link>
                                    </p>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="dashboard__importSidebarHeader">
                                    <p>File summary</p>
                                </div>
                                <div className="dashboard__importSidebarBody">
                                    <div className="dashboard__importSidebarTop">
                                        <div className="dashboard__importSidebarIcon">
                                            <i className="fa-solid fa-user-check"></i>
                                        </div>
                                        <div className="dashboard__importSidebarContent">
                                            <span className="dashboard__importSidebarCount">{message === "success" ? totalCustomer : "0"}</span>
                                            <span className="dashboard__importSidebarText">Transactions Found</span>
                                        </div>
                                    </div>
                                    <div className="dashboard__importSidebarBottom">
                                        <img src={summaryFileIcon} alt="" />
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImportTransaction;
